const initialState = {
  membersList: null,
  waitingPeriods: [],
};

export default {
  namespaced: true,

  state: { ...initialState },

  mutations: {
    updateMembersList(state, data) {
      state.membersList = data;
    },

    updateWaitingPeriods(state, data) {
      state.waitingPeriods = data;
    },
  },

  getters: {
    getMemberList: (state) => {
      return state.membersList;
    },

    getWaitingPeriods: (state) => {
      return state.waitingPeriods;
    },
  },
};
